import { SvgIcon, SxProps } from "@mui/material";
import ReactionLikeSvg from "jsx:../../../Images/Icons/Custom/reactionDislike.svg";

export function ReactionDislikeIcon(props: SxProps) {
    return <SvgIcon component={ReactionLikeSvg} inheritViewBox sx={props} />;
}
